import MainLayout from "@/components/layout/applicant/MainLayout.vue";
export default {
    name: "termsOfService",
    components: {
        MainLayout
    }
};